<template>
  <div>
    <v-breadcrumbs
      :items="breadcrumbs"
      class="grey lighten-2 white--text"
    ></v-breadcrumbs>
    <v-progress-circular
      v-if="loading"
      :size="100"
      :width="4"
      color="fmq_black"
      indeterminate
      class="d-flex mx-auto py-8 mt-8"
    ></v-progress-circular>
    <div v-else>
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-4">
          <v-btn small depressed color="fmq_gray" dark outlined to="/">
            <v-icon small> mdi-arrow-left </v-icon>Voltar</v-btn
          >
        </div>
        <ProdutoFormulario
          :item="item"
          :listLines="listLines"
          :listLaboratories="listLaboratories"
          :listClassifications="listClassifications"
          :listAnatomiesPhysiologies="listAnatomiesPhysiologies"
          :listPathologies="listPathologies"
          :listProducts="listProducts"
          :listSpecialties="listSpecialties"
        />
      </div>
    </div>
    <AlertError :alertError="error" :messageError="messageError" />
  </div>
</template>

<script>
import { listSpecialty } from "@/services/specialty";
import { listLine } from "@/services/line";
import { listLaboratory } from "@/services/laboratory";
import { listClassification } from "@/services/classification";
import { listAnatomyPhysiology } from "@/services/anatomy-physiology";
import { listPathology } from "@/services/pathology";
import { listProduct, showProduct } from "@/services/product";
import ProdutoFormulario from "@/components/produtos/ProdutoFormulario.vue";
export default {
  name: "ProdutoVisualizar",
  components: { ProdutoFormulario },
  data: () => ({
    breadcrumbs: [
      {
        text: "Produtos",
        disabled: false,
        to: "/",
      },
      {
        text: "Visualizar Produto",
        disabled: true,
        to: "",
      },
    ],
    error: false,
    messageError: null,
    item: {},
    loading: false,
    listLines: [],
    listLaboratories: [],
    listClassifications: [],
    listAnatomiesPhysiologies: [],
    listPathologies: [],
    listProducts: [],
    listSpecialties: [],
  }),
  created() {
    this.listarLinhas();
    this.listarLaboratorios();
    this.listarClassificacoes();
    this.listarAnatomiasPatologias();
    this.listarPatologias();
    this.listarProdutos();
    this.listarEspecialidades();
    this.exibir();
  },
  methods: {
    async exibir() {
      this.error = false;
      this.loading = true;
      try {
        const resp = await showProduct(this.$route.params.id);
        this.item = resp.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.error = true;
        this.messageError =  e.response.data.message;
      }
    },
    async listarLinhas() {
      const resp = await listLine();
      this.listLines = resp.data;
    },
    async listarLaboratorios() {
      const resp = await listLaboratory();
      this.listLaboratories = resp.data;
    },
    async listarClassificacoes() {
      const resp = await listClassification();
      this.listClassifications = resp.data;
    },
    async listarAnatomiasPatologias() {
      const resp = await listAnatomyPhysiology();
      this.listAnatomiesPhysiologies = resp.data;
    },
    async listarPatologias() {
      const resp = await listPathology();
      this.listPathologies = resp.data;
    },
    async listarProdutos() {
      let data = new FormData();
      data.append("labels[]", "name");
      data.append("labels[]", "laboratory:name");
      const resp = await listProduct(data);
      this.listProducts = resp.data;
    },
    async listarEspecialidades() {
      const resp = await listSpecialty();
      this.listSpecialties = resp.data;
    },
  },
};
</script>

<style></style>
